/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_Source_Text_HelpInputs */



/**
* | output |
* | --- |
* | "Copies source-language text (source text to original, or original back to source text)" |
*
* @param {Event_Group_Sync_Property_Source_Text_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_source_text_help = /** @type {((inputs?: Event_Group_Sync_Property_Source_Text_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_Source_Text_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copies source-language text (source text to original, or original back to source text)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Copies source-language text (source text to original, or original back to source text)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copies source-language text (source text to original, or original back to source text)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Copies source-language text (source text to original, or original back to source text)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copies source-language text (source text to original, or original back to source text)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Copies source-language text (source text to original, or original back to source text)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Copies source-language text (source text to original, or original back to source text)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Copies source-language text (source text to original, or original back to source text)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copies source-language text (source text to original, or original back to source text)")
	return /** @type {LocalizedString} */ ("Copies source-language text (source text to original, or original back to source text)")
});